'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fonts = exports.verticalRhythmByUnit = exports.verticalScaledRhythmByPixel = exports.verticalRhythmByPixel = exports.radiusByUnit = exports.radiusByPixel = exports.scaledRhythmByPixel = exports.rhythmByUnit = exports.rhythmByPixel = exports.createVerticalRhythm = exports.createRhythmByUnit = exports.createRhythmByPixel = exports.RADIUS = exports.SCALE = exports.STEP = undefined;
exports['default'] = createTypography;

var _deprecate = require('../utils/deprecate');

var _deprecate2 = _interopRequireDefault(_deprecate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var STEP = exports.STEP = 8;
var SCALE = exports.SCALE = 1.2; // Minor Third
var RADIUS = exports.RADIUS = 0.2;

var createRhythmByPixel = exports.createRhythmByPixel = function createRhythmByPixel(h) {
  return function (v) {
    var r = Math.ceil(v / h) * h;
    return (r === v ? r + h : r) + 'px';
  };
};

var createRhythmByUnit = exports.createRhythmByUnit = function createRhythmByUnit(h) {
  return function (u) {
    return Math.round(parseFloat(u) * h) + 'px';
  };
};

var createVerticalRhythm = exports.createVerticalRhythm = function createVerticalRhythm(fn) {
  return function (v) {
    return {
      fontSize: v,
      lineHeight: fn(v)
    };
  };
};

var rhythmByPixel = exports.rhythmByPixel = createRhythmByPixel(STEP);
var rhythmByUnit = exports.rhythmByUnit = createRhythmByUnit(STEP);
// Used to account for font ascendors and descendors when determining font line height
var scaledRhythmByPixel = exports.scaledRhythmByPixel = function scaledRhythmByPixel(u) {
  return rhythmByPixel(u * SCALE);
};

var radiusByPixel = exports.radiusByPixel = function radiusByPixel(u) {
  return parseInt(rhythmByPixel(u)) * RADIUS + 'px';
};
var radiusByUnit = exports.radiusByUnit = function radiusByUnit(u) {
  return parseInt(rhythmByUnit(u)) * RADIUS + 'px';
};

var verticalRhythmByPixel = exports.verticalRhythmByPixel = createVerticalRhythm(rhythmByPixel);
var verticalScaledRhythmByPixel = exports.verticalScaledRhythmByPixel = createVerticalRhythm(scaledRhythmByPixel);
var verticalRhythmByUnit = exports.verticalRhythmByUnit = createVerticalRhythm(rhythmByUnit);

var deprecateVerticalRhythm = (0, _deprecate2['default'])('verticalRhythm will be removed. Use verticalRhythmByPixel instead.', verticalRhythmByPixel);

var fonts = exports.fonts = {
  monospace: Object.assign({
    fontFamily: '"SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier, monospace',
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightHeavy: 600
  }, verticalScaledRhythmByPixel(13)),
  sansSerif: Object.assign({
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightHeavy: 600,
    letterSpacing: 0
  }, verticalScaledRhythmByPixel(13)),
  serif: Object.assign({
    fontFamily: 'Georgia, Times, "Times New Roman", serif',
    fontWeightLight: 100,
    fontWeightRegular: 300,
    fontWeightMedium: 500,
    fontWeightHeavy: 700
  }, verticalScaledRhythmByPixel(13))
};

var defaultConstants = fonts.sansSerif;

function createTypography(palette) {
  var constants = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultConstants;

  return Object.assign({}, constants, {
    display4: Object.assign({
      fontWeight: fonts.sansSerif.fontWeightLight,
      fontFamily: fonts.sansSerif.fontFamily,
      letterSpacing: fonts.sansSerif.letterSpacing,
      color: palette.text.primary
    }, verticalScaledRhythmByPixel(112)),
    display3: Object.assign({
      fontWeight: fonts.sansSerif.fontWeightRegular,
      fontFamily: fonts.sansSerif.fontFamily,
      letterSpacing: fonts.sansSerif.letterSpacing,
      color: palette.text.primary
    }, verticalScaledRhythmByPixel(56)),
    display2: Object.assign({
      fontWeight: fonts.sansSerif.fontWeightRegular,
      fontFamily: fonts.sansSerif.fontFamily,
      letterSpacing: fonts.sansSerif.letterSpacing,
      color: palette.text.primary
    }, verticalScaledRhythmByPixel(45)),
    display1: Object.assign({
      fontWeight: fonts.sansSerif.fontWeightRegular,
      fontFamily: fonts.sansSerif.fontFamily,
      letterSpacing: fonts.sansSerif.letterSpacing,
      color: palette.text.primary
    }, verticalScaledRhythmByPixel(22)),
    title: Object.assign({
      fontWeight: fonts.sansSerif.fontWeightRegular,
      fontFamily: fonts.sansSerif.fontFamily,
      letterSpacing: fonts.sansSerif.letterSpacing,
      color: palette.text.primary
    }, verticalScaledRhythmByPixel(20)),
    headline: Object.assign({
      fontWeight: fonts.sansSerif.fontWeightMedium,
      fontFamily: fonts.sansSerif.fontFamily,
      letterSpacing: fonts.sansSerif.letterSpacing,
      color: palette.text.primary
    }, verticalScaledRhythmByPixel(15)),
    subheading: Object.assign({
      fontWeight: fonts.sansSerif.fontWeightRegular,
      fontFamily: fonts.sansSerif.fontFamily,
      letterSpacing: fonts.sansSerif.letterSpacing,
      color: palette.text.primary
    }, verticalScaledRhythmByPixel(12)),
    body1: {
      fontSize: fonts.sansSerif.fontSize,
      fontWeight: fonts.sansSerif.fontWeightRegular,
      fontFamily: fonts.sansSerif.fontFamily,
      letterSpacing: fonts.sansSerif.letterSpacing,
      color: palette.text.primary,
      lineHeight: fonts.sansSerif.lineHeight
    },
    body2: {
      fontSize: fonts.serif.fontSize,
      fontWeight: fonts.sansSerif.fontWeightMedium,
      fontFamily: fonts.sansSerif.fontFamily,
      letterSpacing: fonts.sansSerif.letterSpacing,
      color: palette.text.primary,
      lineHeight: fonts.serif.lineHeight
    },
    menugroup: Object.assign({
      fontWeight: fonts.sansSerif.fontWeightRegular,
      fontFamily: fonts.sansSerif.fontFamily,
      letterSpacing: fonts.sansSerif.letterSpacing,
      color: palette.text.primary,
      textTransform: 'uppercase'
    }, verticalScaledRhythmByPixel(11)),
    caption: Object.assign({
      fontWeight: fonts.sansSerif.fontWeightRegular,
      fontFamily: fonts.sansSerif.fontFamily,
      letterSpacing: fonts.sansSerif.letterSpacing,
      color: palette.text.primary
    }, verticalScaledRhythmByPixel(10)),
    description: Object.assign({
      fontWeight: fonts.sansSerif.fontWeightRegular,
      fontFamily: fonts.sansSerif.fontFamily,
      letterSpacing: fonts.sansSerif.letterSpacing,
      color: palette.text.primary
    }, verticalScaledRhythmByPixel(12)),
    paragraph: {
      marginBottom: rhythmByUnit(1)
    },
    code: Object.assign({}, fonts.monospace, {
      color: palette.text.primary
    }),
    materialIcon: {
      fontFamily: 'Material Icons',
      fontWeight: 'normal',
      fontStyle: 'normal',
      fontSize: 24,
      display: 'inline-block',
      lineHeight: 1,
      textTransform: 'none'
    },
    highlight: {
      color: palette.text.highlight
    },
    disabled: {
      color: palette.text.disabled
    },
    error: {
      fontStyle: 'normal',
      color: palette.text.error
    },
    success: {
      color: palette.text.success
    },
    primary: {
      color: palette.text.primary
    },
    secondary: {
      color: palette.text.secondary
    },
    radiusByPixel: radiusByPixel,
    radiusByUnit: radiusByUnit,
    rhythmByPixel: rhythmByPixel,
    rhythmByUnit: rhythmByUnit,
    verticalRhythmByPixel: verticalRhythmByPixel,
    verticalScaledRhythmByPixel: verticalScaledRhythmByPixel,
    verticalRhythmByUnit: verticalRhythmByUnit,
    verticalRhythm: deprecateVerticalRhythm
  });
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/styles/typography.js
// module id = 155
// module chunks = 32